import { Alert } from 'react-bootstrap';
import TableTopicSubtopics from '../TableTopicSubtopics';
import TableLingvoAnylize from '../TableLingvoAnylize';

function TableResults(props) {

    const {menu, topicsData, lingoAnalizeData} = props;

    return (
        <>
            { menu === '' ? (
                <Alert variant="danger">Нет данных</Alert>
            ) : ''}
            { menu === 'topics' ? (
                <TableTopicSubtopics data={topicsData}></TableTopicSubtopics>
            ) : ''}  
            { menu === 'lingvo' ? (
                <TableLingvoAnylize data={lingoAnalizeData}></TableLingvoAnylize>
            ) : ''}  
        </>
    );
}


export default TableResults;
